export const PDF_GREY_BG_COLOR = "#CCCCCC";
export const PDF_GREY_ROW_COLOR = "#f5f5f5";
export const PDF_WHITE_ROW_COLOR = "#ffffff";
export const PDF_TABLE_BORDER_COLOR = "#e8e8e8";
export const PDF_BLACK = "#000";